import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';

import { useHost } from '@xing-com/crate-xinglet';

import copy from './copy';

const shortcutIco =
  'https://www.xing.com/assets/frontend_minified/img/shared/xing_r1.ico';
const appleIco =
  'https://www.xing.com/assets/frontend_minified/img/shared/xing_icon_apple.png';

type HeadProps = {
  page: 'startPage' | 'languagePage';
};

export const Head: React.FC<React.PropsWithChildren<HeadProps>> = ({
  page = 'startPage',
  children,
}) => {
  const { formatMessage } = useIntl();
  const { isPreview } = useHost();

  const externalUrl = isPreview
    ? 'https://preview.xing.com '
    : 'https://www.xing.com';

  return (
    <Helmet>
      <title>{formatMessage(copy[`${page}Title`])}</title>
      <meta
        name="description"
        content={formatMessage(copy[`${page}Description`])}
      />
      <meta name="HandHeldFriendly" content="true" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black" />
      <meta name="p:domain_verify" content="67d537533de2cff8410b2b6048c8de0d" />
      <meta property="og:title" content={formatMessage(copy[`${page}Title`])} />
      <meta
        property="og:site_name"
        content={formatMessage(copy[`${page}SiteName`])}
      />
      <meta property="og:url" content={externalUrl} />
      <meta
        property="og:image"
        content="https://static.xingcdn.com/og-cover-image.png"
      />
      <meta
        property="og:description"
        content={formatMessage(copy[`${page}Description`])}
      />
      <meta property="og:type" content="website" />
      <link rel="shortcut icon" href={shortcutIco} type="image/ico" />
      <link rel="apple-touch-icon" href={appleIco} />
      <link
        rel="search"
        type="application/opensearchdescription+xml"
        title="XING"
        href="/media/xing-opensearch.xml"
      />
      <link rel="canonical" href="https://www.xing.com" />
      {children}
    </Helmet>
  );
};
